jQuery(function($){

  $('.tab-nav').on('click', function(){

    const target = $(this).data('tab');

    $('.tab-nav').removeClass('is-active');
    $('.shop-tab-panel').removeClass('is-active');

    $(this).addClass('is-active');
    $('#' + target).addClass('is-active');


    if(target === 'shop-list'){
      $('#shop-area-list').addClass('is-active');
    }else{
      $('#shop-area-list').removeClass('is-active');
    }

  });

});
